import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Paths from "@/constants/paths";
import type { ActionDataBo } from "@/types/tableAction";

export function useFinalizeDraftRedirect(
  actionData: ActionDataBo | null,
  setActionData: (value: ActionDataBo | null) => void,
) {
  const navigate = useNavigate();

  useEffect(() => {
    if (actionData?.action !== "FINALIZE" && actionData?.action !== "MODIFY") return;
    if (!actionData.expedition.draftBy) return;
    const apiEnum = actionData.expedition.expeditionFedexApi ? "FEDEX" : "NONE";
    const path = Paths.bo.expeditionForm.replace(":id", actionData.expedition.id);
    setActionData(null);
    navigate(path, { state: { apiEnum } });
  }, [actionData, navigate, setActionData]);
}
